<template>
    <div v-if="overviewHref" class="d-flex gap-2 pt-4 border-top mt-4">
        <a
            :href="overviewHref"
            class="btn btn-white flex-grow-1"
            target="_blank"
            rel="noopener"
        >
            {{ $t('audits.panels.auditImport.openReport') }}
            <i class="fi fi-external-link" aria-hidden="true"></i>
            <span class="visually-hidden">
                {{ $t('audits.panels.auditImport.opensInNewTab') }}
            </span>
        </a>
    </div>
</template>

<script>
/**
 * Footer for an imported audit, laid out like the audit panel footer.
 * It shows "Open report" (new tab) only for audits that have an Overview page.
 */
export default {
    name: 'AuditImportPreviewFooter',
    props: {
        overviewHref: {
            type: String,
            default: null,
        },
    },
};
</script>
